import { initChannels } from '../../../actions/channels/initChannels';
import { useAppSelector } from '../../../store/hooks';
import { useEffect } from 'react';
import { userSelector } from '../../../store/slices/user.slice';

export default function useChannels() {
  const { initialized } = useAppSelector(userSelector);

  // Fetch channels after all required data is obtained

  useEffect(() => {
    initialized && initChannels();
  }, [initialized]);
}
